// Third Party Libraries Imports
import toast from "react-hot-toast";
// import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";

class EditFundService {
  private navigate = useNavigate();
  private dispatch = useDispatch();

  // public async getDepositDetailsData(
  //   depositId: string | undefined
  // ): Promise<any[] | undefined> {
  //   this.dispatch({ type: LOADING, payload: true });

  //   try {
  //     const response: AxiosResponse<{
  //       data: any[];
  //       message: string;
  //     }> = await instance.get(`/deposit/${depositId}`);
  //     return response.data.data;
  //   } catch (error: any) {
  //     toast.error(error?.response?.data?.message || "An error occurred");
  //     return undefined;
  //   } finally {
  //     this.dispatch({ type: LOADING, payload: false });
  //   }
  // }

  public async submitForm(
    fundId: string | undefined,
    values: any
  ): Promise<void> {
    this.dispatch({ type: LOADING, payload: true });

    this.dispatch({ type: LOADING, payload: true });
    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/option/mutual-funds/${fundId}`, values);
      toast.success("Fund updated successfully");
      this.navigate(`/funds`);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/funds/edit-fund/${fundId}`);
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default EditFundService;
